<template>
  <v-container
    grid-list-md
    justify-start
    fluid
  >
    <v-layout row>
      <home-item-title>
        {{ $t("home.status") }}
      </home-item-title>
    </v-layout>
    <v-layout row>
      <v-container class="pa-0">
        <div class="home-player">
          <v-container
            grid-list-md
            justify-start
            fluid
            class="pa-1"
          >
            <players-list-item
              v-for="(player, index) in players"
              :key="index"
              :link="player.link"
              :connected="player.connect"
            >
              {{ player.name }}
            </players-list-item>
          </v-container>
        </div>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
// Components
import homeItemTitle from "./HomeItemTitle";
import playersListItem from "./PlayersListItem";

// Connectors
import { PlayerConnector } from "../Database/PlayerConnector";

export default {
  components: {
    homeItemTitle,
    playersListItem,
  },
  data() {
    return {
      playerConnector: new PlayerConnector(this.$store.state.user),
      players: [{}],
    };
  },
  created() {
    if (this.$store.state.user.socId != null) {
      this.collectPlayers();
    }
  },
  methods: {
    collectPlayers() {
      // TODO: Make directly db return all players with connected or not value
      this.playerConnector
        .getAllPlayersNetworkConnect()
        .then((playersConnected) => {
          // MAKE A FUNCTION REEUSE MULTIPLE TIMES
          const playersConnect = playersConnected.map((element) => {
            return element.id_plyr;
          });

          this.playerConnector.getAllPlayers().then((players) => {
            // TODO: format in db server
            this.players = players.map((element) => {
              return {
                id: element.id_plyr,
                name: element.name,
                connect: playersConnect.includes(element.id_plyr) ? true : false,
                link: "/status/" + element.id_plyr,
              };
            });
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style>
.home-player {
  height: 50vh;
  overflow: auto;
}
</style>
